import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from '../../core/api/endpoints';
import { environment } from '../../environments/environment';
import { AccountSettingsRequest } from '../models/company-request';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) { }

  getAllCompanies(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.company.base}`
    );
  }

  getCompanyById(id: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getById(id)}`
    );
  }

  getAccountSettings(comapnyId?: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.getAccountSettings}?companyId=` + comapnyId
    );
  }

  createCompany(company: any): Observable<any> {
    let path: string = `${this.baseUrl}/${Endpoints.company.register}`;
    return this.http.post<any>(path, company);
  }

  updateCompany(company: any): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${Endpoints.company.base}`, company);
  }

  getUserProfile(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.getUserProfile(id)}`
    );
  }

  sendWelcomeMail(email: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.company.sendWelcomeEmail(email)}`, null
    );
  }

  sendEmailOtp(email: string): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.company.sendEmailOtp(email)}`, null
    );
  }

  verifyEmailOtp(request: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.company.verifyEmailOtp}`, request);
  }

  updateUserProfile(contact: any): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${Endpoints.company.updateUserProfile}`, contact);
  }

  createUserProfile(contact: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/${Endpoints.company.createUserProfile}`, contact);
  }

  updateAccountSettings(accountSettings: AccountSettingsRequest): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/${Endpoints.company.updateAccountSettings}`, accountSettings);
  }

  deleteUserProfile(id: number): Observable<number> {
    return this.http.delete<number>(
      `${this.baseUrl}/${Endpoints.company.deleteUserProfile(id)}`);
  }

  getAllStates(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.lookupState.base}`
    );
  }

  getAllPrefixes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.lookupPrefix.base}`
    );
  }

  getAllSuffixes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.lookupSuffix.base}`
    );
  }

  getAllEntityTypes(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.lookupEntityType.base}`
    );
  }

  getAllIndustries(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.lookupIndustry.base}`
    );
  }

  getAllVouchers(companyId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getVoucherFiles(companyId)}`
    );
  }

  getW9(companyId: string): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getW9(companyId)}`
    );
  }

  getW9List(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getAllW9}`
    );
  }

  getW9NotApprovedList(): Observable<any> {
    return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getAllW9NotApproved}`
    );
  }

  updateW9Status(list: any[]): Observable<any[]> {
    return this.http.post<any[]>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.updateW9Status}`
      , list);
  }

  secure()
  {
     return this.http.get<any>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.secure}`
    );
  }

  downloadFile(payload: any): Observable<Blob>  {
    return this.http.post(
      `${this.baseUrl}/${Endpoints.company.downloadFile}`,
    payload,
    {
      responseType: 'blob'
    }
  );
  }

  uploadW9(companyId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.uploadW9(companyId)}`,
      formData
    );
  }

  canDeleteAccount(companyId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.canDeleteAccount(companyId)}`
    );
  }

  deleteAccount(companyId: number): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.deleteAccount(companyId)}`
    );
  }

  getCompanyEIN(companyId: string): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.getCompanyEIN(companyId)}`
    );
  }

  uploadNewW9(companyId: string,ein: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.uploadNewW9(companyId,ein)}`,
      formData
    );
  }

  sendW9VerificationEmails(id: string): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/${Endpoints.company.base}/${Endpoints.company.sendW9VerificationEmails(id)}`
    );
  }
}
